import { Fragment } from 'react';
import { Box, Typography, FormControl, RadioGroup, FormControlLabel, Radio } from '@mui/material';
import BuildIcon from '@mui/icons-material/Build';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';

const fontFamily = '"Inter", sans-serif';

const ProposalViewSystemWorks = ({ arr, handleChange, system_index }) => (
  <Fragment>
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2, mt: 4 }}>
      <BuildIcon sx={{ fontSize: 20, color: '#0d3c61' }} />
      <Typography
        sx={{
          fontFamily,
          fontWeight: 600,
          fontSize: 14,
          color: '#1a1a1a',
          textTransform: 'uppercase',
          letterSpacing: '0.5px',
        }}
      >
        Scope of Work
      </Typography>
    </Box>

    <Box
      sx={{
        backgroundColor: '#f8f9fa',
        borderRadius: 1,
        p: 2,
      }}
    >
      {arr.map((el, idx) =>
        el.flexibleItems.length > 0 && (
          <Fragment key={idx}>
            {el.flexibleItems.length < 2 ? (
              // Single work item
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'flex-start',
                  gap: 1.5,
                  py: 1,
                  borderBottom: idx < arr.length - 1 ? '1px solid #e0e0e0' : 'none',
                }}
              >
                <CheckCircleOutlineIcon 
                  sx={{ 
                    fontSize: 18, 
                    color: '#4caf50',
                    mt: 0.2,
                  }} 
                />
                <Typography
                  sx={{
                    fontFamily,
                    fontSize: 13,
                    color: '#333',
                    lineHeight: 1.6,
                  }}
                >
                  {el.flexibleItems[0].item.description}
                </Typography>
              </Box>
            ) : (
              // Multiple work options
              <Box
                sx={{
                  py: 1,
                  borderBottom: idx < arr.length - 1 ? '1px solid #e0e0e0' : 'none',
                }}
              >
                <Typography
                  sx={{
                    fontFamily,
                    fontSize: 12,
                    color: '#666',
                    mb: 1,
                  }}
                >
                  Select an option:
                </Typography>
                <FormControl fullWidth>
                  <RadioGroup
                    value={el.selectedItemIndex}
                    onChange={(event) => handleChange(event, system_index, 'scopeOfWorks', el)}
                  >
                    {el.flexibleItems.map((item, item_index) => (
                      <FormControlLabel
                        value={item_index}
                        key={item_index}
                        control={
                          <Radio 
                            size="small"
                            sx={{ 
                              color: '#0d3c61',
                              '&.Mui-checked': { color: '#0d3c61' },
                            }}
                          />
                        }
                        label={
                          <Typography sx={{ fontFamily, fontSize: 13, color: '#333' }}>
                            {item.item.description}
                          </Typography>
                        }
                        sx={{
                          m: 0,
                          py: 0.5,
                        }}
                      />
                    ))}
                  </RadioGroup>
                </FormControl>
              </Box>
            )}
          </Fragment>
        )
      )}
    </Box>
  </Fragment>
);

export default ProposalViewSystemWorks;
